var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftArrowB(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.50024 3.49999H1.91523L4.35523 1.05999C4.55023 0.864985 4.55023 0.544985 4.35523 0.349985C4.16023 0.154985 3.84523 0.154985 3.65023 0.349985L0.355234 3.64499C0.160234 3.83999 0.160234 4.15499 0.355234 4.34999L3.65023 7.64499C3.84523 7.83999 4.16023 7.83999 4.35523 7.64499C4.55023 7.44999 4.55023 7.13498 4.35523 6.93998L1.91523 4.49999H7.50024C7.77524 4.49999 8.00024 4.27499 8.00024 3.99999C8.00024 3.72499 7.77524 3.49999 7.50024 3.49999Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrowB);
export default __webpack_public_path__ + "static/media/left-arrow-b.e5d7a3c7683b901179801b9350bc0537.svg";
export { ForwardRef as ReactComponent };